import { Fragment, useEffect, useState } from "react";
import SelectDynamicInputCard from "./SelectDynamicInputCard";
import Filters from "../Filters/Filters";

const SelectDynamicNew = (props) => {
  const [selectRouteInputs, setSelectRouteInputs] = useState([]);
  const [newFilters, setNewFilters] = useState([]);
  let selectSS =
    Object.keys(props.selectDynamicData).length > 0 && props.selectDynamicData;

  useEffect(() => {
    if (props.pageType === "create") {
      setSelectRouteInputs([selectSS]);
    }
  }, [selectSS]);

  useEffect(() => {
    if (props.pageType === "edit") {
      const inputDataNewObject = props.inputData;
      const options = props.editDataValue;
      const lastLevelValue =
        inputDataNewObject[props.keyItem].slice(-1)[0].value;
      inputDataNewObject[props.keyItem] = lastLevelValue;
      let newCategories = options.map((item, index) => {
        const newItemFilters = [];
        if (item.filters && props.inputData.filters) {
          for (let obj of item.filters) {
            for (let item of props.inputData.filters) {
              if (item.id === obj.id) {
                obj[item.id] = item.value;
                newItemFilters.push({ ...obj });
              }
            }
          }
          if (item.filters.length > 0) {
            // setNewFilters(newItemFilters);
          }
        }
        return {
          [props.keyItem + "-" + index]: item.options,
          label: item.label,
        };
      });
      setSelectRouteInputs(newCategories);
    }
  }, [setSelectRouteInputs]);

  useEffect(() => {
    if (props.pageType === "create") {
      const inputDataNewObject = props.inputData;
      if (props.pageType === "create") {
        inputDataNewObject["filters"] = {};
        props.setInputData(inputDataNewObject);
      }
    }
  }, [newFilters]);
  console.log(newFilters, props.inputData, "sdjfueuu");
  return (
    <div className="col-span-full sm:col-auto z-50">
      <Fragment>
        <div className="w-full relative rounded-md col-span-full sm:col-auto">
          {selectRouteInputs.length !== 0 &&
            selectRouteInputs[0] !== false &&
            selectRouteInputs.map((item, index) => {
              return (
                <SelectDynamicInputCard
                  disabled={props.item.disabled}
                  key={index}
                  editData={props.editData}
                  inputData={props.inputData}
                  pageType={props.pageType}
                  label={item.label ?? ""}
                  setInputData={props.setInputData}
                  setNewFilters={setNewFilters}
                  setSelectRouteInputs={setSelectRouteInputs}
                  selectRouteInputs={selectRouteInputs}
                  id={props.keyItem + "-" + index}
                  matchOptionId={"matches-option" + index}
                  options={Object.values(item)[0]}
                  optionKeys={Object.keys(item)}
                  route={props.route}
                  keyItem={props.keyItem}
                />
              );
            })}
        </div>
        <div className="mt-2 text-[.8rem] text-edit_input_validation">
          {props.children}
        </div>
        <div>
          <div className="text-[14px] flex flex-col gap-4">
            {newFilters.length !== 0 && (
              <div className="border-b pb-1 mb-2">ویژگی ها</div>
            )}
            {newFilters.length !== 0 &&
              newFilters.map((item, index) => {
                return (
                  <Filters
                    item={item}
                    HasManyInputData={props.HasManyInputData}
                    HasManyKey={props.HasManyKey}
                    inputData={props.inputData}
                    index={props.index}
                  />
                );
              })}
          </div>
        </div>
      </Fragment>
    </div>
  );
};

export default SelectDynamicNew;
